import "./rightprofile.css";
import React, { useEffect, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import CustomCarousel from "./customCarousel/customCarousel";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

function RightProfile({ user }) {
  const navigate = useNavigate();
  const { tailor_id } = useParams();

  const [isMobileView, setIsMobileView] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showAllCards, setShowAllCards] = useState({});
  const [loadedImages, setLoadedImages] = useState({});

  const cardData = useSelector((state) => state.cardData);
  const subIndex = useSelector((state) => state.subIndex);
  const loading = useSelector((state) => state.loading);

  // Handle image load
  const handleImageLoad = (cardIndex, imageIndex) => {
    setLoadedImages((prev) => ({
      ...prev,
      [`${cardIndex}-${imageIndex}`]: true,
    }));
  };

  // Check if image is loaded
  const isImageLoaded = (cardIndex, imageIndex) => {
    return loadedImages[`${cardIndex}-${imageIndex}`] === true;
  };

  // Rest of your existing code...
  const toggleShowCards = (subOutfitType) => {
    setShowAllCards({
      ...showAllCards,
      [subOutfitType]: !showAllCards[subOutfitType],
    });
  };

  const openImageModal = (cardIndex, imageIndex) => {
    if (
      cardData[cardIndex] &&
      cardData[cardIndex].portfolio_outfits[imageIndex]
    ) {
      const images =
        cardData[cardIndex].portfolio_outfits[imageIndex].image_url;
      if (images) {
        setSelectedImage(images);
        setOpenModal(true);
      }
    }
  };

  const getInitialCards = (outfitType) => {
    const outfitData = cardData.find((data) => data.outfit_type === outfitType);
    if (outfitData) {
      const cards = outfitData.portfolio_outfits;
      return cards ? cards.slice(0, 4) : [];
    }
    return [];
  };

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 768) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Add this useEffect to preload images
  useEffect(() => {
    if (cardData && cardData.length > 0) {
      // Preload first few images from each category
      cardData.forEach((data, cardIndex) => {
        if (data.portfolio_outfits && data.portfolio_outfits.length > 0) {
          // Only preload the first 4 images to save bandwidth
          const imagesToPreload = data.portfolio_outfits.slice(0, 4);

          imagesToPreload.forEach((outfit, imageIndex) => {
            if (outfit.image_url && outfit.image_url.length > 0) {
              const img = new Image();
              img.onload = () => handleImageLoad(cardIndex, imageIndex);
              img.src = outfit.image_url[0];
            }
          });
        }
      });
    }
  }, [cardData]);

  const handleShowAllClick = (outfitType) => {
    const subIndexName = subIndex[outfitType];
    navigate(`/${tailor_id}/${subIndexName}`);
  };

  return (
    <div className="rightProfile">
      {isMobileView ? (
        <div className="rightProfileItems">
          {/* mobile view  */}
          {cardData && cardData.length > 0 ? (
            cardData.map((data, cardIndex) => (
              <div key={data.outfit_type} className="subOutfit">
                <div className="rightProfileHeader">
                  {data.outfit_type}
                  <span
                    onClick={() => handleShowAllClick(data.outfit_type_ordinal)}
                    style={{ color: "#4D7AFF", cursor: "pointer", paddingLeft: "5px", paddingRight: "10px" }}
                  >
                    Show All
                  </span>
                </div>
                <div className="card-container-mobile">
                  {getInitialCards(data.outfit_type).map((card, imageIndex) => (
                    <div
                      className="card-scrollable"
                      key={imageIndex}
                      onClick={() =>
                        handleShowAllClick(data.outfit_type_ordinal)
                      }
                    >
                      {!isImageLoaded(cardIndex, imageIndex) && (
                        <div className="image-loading-placeholder">
                          <FontAwesomeIcon
                            icon={faSpinner}
                            spinPulse
                            size="2x"
                          />
                        </div>
                      )}
                      <img
                        src={card.image_url[0]}
                        alt="..."
                        className="card-img-top"
                        style={{
                          display: isImageLoaded(cardIndex, imageIndex)
                            ? "block"
                            : "none",
                        }}
                        onLoad={() => handleImageLoad(cardIndex, imageIndex)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            ))
          ) : (
            <p>No data available</p>
          )}
          {loading && (
            <div style={{ textAlign: "center", justifyContent: "center" }}>
              <FontAwesomeIcon icon={faSpinner} spinPulse size="2x" />
            </div>
          )}
        </div>
      ) : (
        <div className="rightProfileItems">
          {cardData && cardData.length > 0 ? (
            cardData.map((data, cardIndex) => (
              <div key={data.outfit_type} className="subOutfit">
                <div className="rightProfileHeader">
                  <p
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: "20px",
                      lineHeight: "100%",
                      letterSpacing: "0.07px",
                    }}
                  >
                    {data.outfit_type}
                  </p>

                  <div
                    className="rightProfileHeaderContent"
                    onClick={() => toggleShowCards(data.outfit_type)}
                    style={{ cursor: "pointer" }}
                  >
                    {showAllCards[data.outfit_type] ? "Show Less" : "Show All"}
                  </div>
                </div>
                <div className="card-container">
                  {showAllCards[data.outfit_type]
                    ? data.portfolio_outfits.map((card, imageIndex) => (
                        <div
                          className="card"
                          key={imageIndex}
                          onClick={() => openImageModal(cardIndex, imageIndex)}
                        >
                          {!isImageLoaded(cardIndex, imageIndex) && (
                            <div className="image-loading-placeholder">
                              <FontAwesomeIcon
                                icon={faSpinner}
                                spinPulse
                                size="2x"
                              />
                            </div>
                          )}
                          <img
                            src={card.image_url[0]}
                            alt="..."
                            className="card-img-top"
                            style={{
                              display: isImageLoaded(cardIndex, imageIndex)
                                ? "block"
                                : "none",
                            }}
                            onLoad={() =>
                              handleImageLoad(cardIndex, imageIndex)
                            }
                          />
                          <div className="card-body">
                            <h5 className="card-title">{card.title}</h5>
                            <p className="card-text">{card.creation_time}</p>
                          </div>
                        </div>
                      ))
                    : getInitialCards(data.outfit_type).map(
                        (card, imageIndex) => (
                          <div
                            className="card"
                            key={imageIndex}
                            onClick={() =>
                              openImageModal(cardIndex, imageIndex)
                            }
                          >
                            {!isImageLoaded(cardIndex, imageIndex) && (
                              <div className="image-loading-placeholder">
                                <FontAwesomeIcon
                                  icon={faSpinner}
                                  spinPulse
                                  size="2x"
                                />
                              </div>
                            )}
                            <img
                              src={card.image_url[0]}
                              alt="..."
                              className="card-img-top"
                              style={{
                                display: isImageLoaded(cardIndex, imageIndex)
                                  ? "block"
                                  : "none",
                              }}
                              onLoad={() =>
                                handleImageLoad(cardIndex, imageIndex)
                              }
                            />
                            <div className="card-body">
                              <h5 className="card-title">{card.title}</h5>
                              <p className="card-text">{card.creation_time}</p>
                            </div>
                          </div>
                        )
                      )}
                </div>
              </div>
            ))
          ) : (
            <h6 style={{ textAlign: "center", justifyContent: "center" }}>
              No Outfits Available
            </h6>
          )}
          {loading && (
            <div style={{ textAlign: "center", justifyContent: "center" }}>
              <FontAwesomeIcon icon={faSpinner} spinPulse size="2x" />
            </div>
          )}
        </div>
      )}

      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        classNames={{
          modal: "custom-modal-class",
        }}
      >
        <CustomCarousel images={selectedImage} />
      </Modal>
    </div>
  );
}

export default RightProfile;
